import { isFunction } from 'lodash-es';
import type { Resolvable } from './Resolvable';

// When the argument is a function, calls the function and returns the value. If
// the argument is not a function, the object itself is returned.
export function resolveValue<T>(obj: Resolvable<T>): T {
	if (isFunction(obj)) return obj();
	return obj;
}
